import React, { FC } from 'react';
import styled, { keyframes } from 'styled-components';
import SvgIcon from '../atoms/SvgIcon';

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const StyledSpinner = styled.div`
  display: inline-block;
  width: 24px;
  height: 24px;
  vertical-align: middle;
  animation: ${rotate} 1s linear infinite;
`;

interface ILoader {
  color?: string;
}

const LoadingSpinner: FC<ILoader> = ({ color = 'white' }) => (
  <StyledSpinner>
    <SvgIcon icon="loader" iconSize="large" color={color} />
  </StyledSpinner>
);

export default LoadingSpinner;
